export default "__VITE_ASSET__Zm21HkSp__"